var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',_vm._b({on:{"click":function($event){return _vm.$emit('click')}}},'Button',{ ..._vm.defaultButtonProps, ..._vm.buttonProps },false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }